import React from "react";

export default function Section3() {
  const reasons = [
    {
      title: "Shopify Plus Platform Expertise",
      description: " Our team delivers enterprise-level Shopify Plus solutions tailored to high-volume, multi-channel businesses.",
    },
    {
      title: " Enterprise Development Approach",
      description: " We design scalable architectures with automation, custom integrations, and advanced Shopify Plus features to support long-term growth.",
    },
    {
      title: "Dedicated UI/UX Strategy",
      description: "Our Shopify Plus designers craft conversion-focused shopping experiences aligned with your brand identity.",
    },
    {
      title: "Performance and Scalability",
      description: " Every store is optimized for speed, stability, high-volume traffic, and mobile usability, ensuring seamless shopping experiences during peak sales events.",
    },
    {
      title: "Long-Term Growth Partnership",
      description: "We provide continuous support, feature updates, and optimization strategies so your Shopify Plus store evolves alongside your business.",
    },
  ];

  return (
    <div className="w-full Section12">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Why Texas Ecommerce Brands Choose Mean3 for Shopify Plus Services

        </h2>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {reasons.map((item, index) => (
            <div
              key={index}
              className={`p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px] ${
                index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
              }`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {item.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
